import { fulRowMorph } from "./helperFnCheckMinStay";

export const BlockMinStay = ({ rate }) => {
  return (
    <div style={{ textAlign: "right", color: "#cc0011" }}>
      <small>{`Доступно при бронировании от ${fulRowMorph(rate)} `}</small>
    </div>
  );
};
